import { setCustomOptions } from '@blade/common/components/paint/src/drawer-options';
import { getConfig, getSeiRtsp } from '@blade-sxp/monitoring-center/api/index';
import { IncidentTypeMap } from '@blade-sxp/monitoring-center/utils/const';
const fillterArr = ['CROWD_CROSS_LINE_STATISTIC', 'VIRTUAL_ZONE_STATISTIC', 'CROSS_LINE_ALERT_DETECT', 'PEDESTRIAN_CROSS_LINE'];
const traffic = ['TRAFFIC_VIOLATION_DETECT', 'NONE_MOTOR_VEHICLE_PEDESTRIAN_DETECT', 'TRAFFIC_CONGESTION_DETECT'];
const genID = (length) => {
    return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
};
export const setTaskMsgArr = (taskData = [], name) => {
    const noLayer = {
        name,
        id: 0,
    };
    const taskMsgArr = [noLayer, ...taskData.map((item) => item)];
    return taskMsgArr;
};
export const getTaskMsg = (taskData, noLayerName) => {
    const updateItem = (item) => {
        item.roiArr = [];
        item.polygonData = [];
        item.incidentType = IncidentTypeMap[item.taskType];
        if (item.directions && !fillterArr.includes(item.taskType) && item.taskType !== 'QUEUE') {
            const directionsObj = {
                status: 'end',
                type: 'arrow',
                options: setCustomOptions('arrow'),
                vertices: item.directions,
            };
            item.polygonData.push(directionsObj);
        }
        if (item.crossLine && item.taskType === 'QUEUE') {
            const roiData = JSON.parse(item.roiData).polygonData;
            const linesItems = roiData.filter(({ type }) => ['lines', 'line'].includes(type));
            item.polygonData.push(...linesItems);
        }
        if (fillterArr.includes(item.taskType)) {
            const roiData = JSON.parse(item.roiData);
            const { data } = roiData.titleList.find(({ type }) => type === 'LINES');
            item.roiArr.push({ id: item.roiId });
            item.polygonData.push(data[0]);
        }
        if (item.taskType === 'TRAFFIC_RETROGRADE_DETECT') {
            const { roi } = JSON.parse(item.roiData);
            item.polygonData = roi;
        }
        if (traffic.includes(item.taskType)) {
            const roiData = JSON.parse(item.roiData);
            const { data } = roiData.titleList.find(({ type }) => type === 'ROI');
            item.polygonData = data;
        }
        if (item.rois) {
            const roisItems = item.rois.map(({ vertices, ...rest }) => {
                const { id } = rest;
                return {
                    id: id,
                    status: 'end',
                    type: 'polygon',
                    options: setCustomOptions('polygon'),
                    vertices: [vertices[vertices.length - 1], ...vertices],
                };
            });
            item.roiArr.push(...roisItems);
            item.polygonData.push(...roisItems);
        }
        item.polygonData.forEach((polygonItem) => {
            if (polygonItem.type === 'lines' || polygonItem.type === 'line') {
                polygonItem.options = setCustomOptions(polygonItem.type);
            }
        });
    };
    const taskMsgArr = setTaskMsgArr(taskData, noLayerName);
    taskMsgArr.forEach((msg) => {
        // const item = { roiArr: [], polygonData: [], ...msg };
        updateItem(msg);
    });
    return taskMsgArr;
};
export const getStreamObj = (node, taskMsg, rtsp) => {
    return {
        title: node.parentName ? `${node.parentName}/${node.name}` : node.name,
        rtsp,
        deviceId: node.id,
        id: node.id,
        taskMsg: taskMsg,
        taskId: '',
        extendData: {},
        polygonData: [],
        keyId: genID(1),
        setting: {},
    };
};
export const getFaceConfigData = async (deviceId, videoStreamObj, videoStreamMsg) => {
    const objTaskMsg = videoStreamMsg.find(({ taskType }) => taskType === 'FACE_ALERT');
    if (!objTaskMsg)
        return;
    const polygonData = objTaskMsg;
    const operateIds = [deviceId];
    const config = await getConfig({ operateIds });
    const { rtspPreviewAddress: rtsp } = await getSeiRtsp(deviceId, String(polygonData.id));
    videoStreamObj.rtsp = rtsp;
    if (config.length)
        videoStreamObj.setting = config[0];
};
